import { useCallback, useMemo } from "react";
const useCounter = (props)=>{
    const { value =1 , min =0 , max =9 , onChange  } = props;
    const isMinimum = useMemo(()=>value <= min, [
        min,
        value
    ]);
    const isMaximum = useMemo(()=>value >= max, [
        max,
        value
    ]);
    const increment = useCallback((e)=>{
        e.preventDefault();
        if (value < max) onChange(value + 1);
    }, [
        max,
        onChange,
        value
    ]);
    const decrement = useCallback((e)=>{
        e.preventDefault();
        if (value >= min) onChange(value - 1);
    }, [
        min,
        onChange,
        value
    ]);
    return {
        value,
        increment,
        decrement,
        isMinimum,
        isMaximum
    };
};
export default useCounter;

//# sourceMappingURL=useCounter.js.map